"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreFinalizeStepQueryToJSON = exports.PreFinalizeStepQueryFromJSONTyped = exports.PreFinalizeStepQueryFromJSON = void 0;
const runtime_1 = require("../runtime");
function PreFinalizeStepQueryFromJSON(json) {
    return PreFinalizeStepQueryFromJSONTyped(json, false);
}
exports.PreFinalizeStepQueryFromJSON = PreFinalizeStepQueryFromJSON;
function PreFinalizeStepQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enrollmentLocationId': !runtime_1.exists(json, 'enrollmentLocationId') ? undefined : json['enrollmentLocationId'],
    };
}
exports.PreFinalizeStepQueryFromJSONTyped = PreFinalizeStepQueryFromJSONTyped;
function PreFinalizeStepQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enrollmentLocationId': value.enrollmentLocationId,
    };
}
exports.PreFinalizeStepQueryToJSON = PreFinalizeStepQueryToJSON;
//# sourceMappingURL=PreFinalizeStepQuery.js.map